import React from 'react';

import InfoTab from '../components/InfoTab/InfoTab';
import DataForm from '../components/DataForm/DataForm';
import ConsentForm from '../components/Consent/ConsentForm';
import CodeReader from '../components/CodeReader/CodeReader';
import SendData from '../components/SendData/SendData';
import TestComponent from '../components/TestComponent/TestComponent';

// import QRCodePage from '../components/CodeReader/QRCodePage';
import Tabs from '../../components/UI/Tabs/Tabs';
// import Counter from '../components/TestComponent/Counter';

const SubmitPage = (props) => {
  return <>
    <section style={{margin: '4rem auto', width: '90%'}}>
      <h1>Neuen Befund anlegen</h1>
      <Tabs titles = {['Info', 'Einverst.', 'Patient', 'QR Code', 'Senden', 'test']}>
        <InfoTab />
        <ConsentForm showDemo={props.config.env !== 'production'} />
        <DataForm />
        <CodeReader />
        <SendData config={props.config} />
      </Tabs>
    </section>
  </>
};

export default SubmitPage;

/*
Profil:
 E-Mail-Adresse
 Handynummer
 Passwort für Login

 Name
 Geburtsdatum
 Postadresse für Datenbank/Rekontaktierung
 Einwilligung Nutzungsbedingung und allgemeine Datenschutzerklärung (jeweils Häkchen setzen)

{
Intern:
"id":3
"submitter_id":1
"send_to_rxdb":false
"reconfirmation_on":null
"locked":false
"consent_version":1
"created_at":"2022-08-24T14:16:08.605Z"
"updated_at":"2022-08-24T14:16:08.605Z"}

QR Code:
"labor_id":42
"pseudonym":null
"date":"2022-08-19"
"medical":null
"key_ver":"1.0"

Consent:
"confirmed":null
·         Einwilligungserklärung für Varianteneintragung und Kontaktaufnahme durch uns bei Studienvorschlägen (Häkchen setzen oder ggf. Unterschrift auf Display (wird so bspw. bei GMDB gehandhabt))

"sig_name":"XX"
"sig_first_name":"X"
"sig_date":"2022-08-24"
"sig_place":"Springfield"
"sig_img":"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"

Form:
"pat_relation":1

"accept_therapy":true
"accept_studies":true
"accept_reevaluation":true
*/